'use strict';

var React = require('react');
var dynamicSizing = require('./dynamicSizing-aed281c8.js');
var lottie = require('lottie-web/build/player/lottie_light');
var index_es$1 = require('./index.es-55fa6858.js');
var index_es = require('./index.es-8c72aff8.js');
var WidgetController_widgets_LottieInfoLayoutCard_type = require('./WidgetController/widgets/LottieInfoLayoutCard/type.js');
var WidgetControllerContext = require('./WidgetControllerContext-924d4968.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var lottie__default = /*#__PURE__*/_interopDefaultLegacy(lottie);

const LottieInfoLayoutCard = ({ info, style, position, }) => {
    const lottieElement = React.useRef(null);
    const playCount = React.useRef(0);
    const direction = React.useRef(0);
    const { sdk, clickAnalytics, impressionAnalytics } = React.useContext(WidgetControllerContext.WidgetControllerContext);
    React.useEffect(() => {
        if (!index_es.N(info.analytics)) {
            if (!index_es.N(info.analytics.impressionObjectName) && !index_es.N(impressionAnalytics)) {
                impressionAnalytics({
                    action: info.analytics.impressionObjectName,
                    category: info.analytics.screenName,
                    label: info.analytics.objectValue,
                    value: position,
                    context: info.analytics.context,
                });
            }
        }
    }, [impressionAnalytics, info.analytics, position]);
    const onLottieClick = React.useCallback(() => {
        if (!index_es.N(info.analytics)) {
            if (!index_es.N(info.analytics.clickObjectName) && !index_es.N(clickAnalytics)) {
                clickAnalytics({
                    action: info.analytics.clickObjectName,
                    category: info.analytics.screenName,
                    label: info.analytics.objectValue,
                    value: position,
                    context: info.analytics.context,
                });
            }
        }
        if (info.action && sdk) {
            const navigateData = {
                type: info.action.type || index_es$1.N.DEEPLINK,
                link: info.action.link || "",
            };
            sdk.navigateToScreen(navigateData).catch(() => undefined);
        }
    }, [clickAnalytics, info.action, info.analytics, position, sdk]);
    const dataReadyEvent = React.useCallback((anim) => {
        playCount.current = 1;
        anim.play();
    }, []);
    const onAnimationComplete = React.useCallback((anim) => {
        var _a, _b;
        if (((_a = info.lotteStyle) === null || _a === void 0 ? void 0 : _a.repeatMode) === WidgetController_widgets_LottieInfoLayoutCard_type.LotteRepeatMode.LOTTE_REPEAT_MODE_RESTART) {
            if (playCount.current < Number(info.lotteStyle.repeatCount) ||
                Number(info.lotteStyle.repeatCount) === -1) {
                playCount.current += 1;
                anim.goToAndPlay(0);
            }
        }
        if (((_b = info.lotteStyle) === null || _b === void 0 ? void 0 : _b.repeatMode) === WidgetController_widgets_LottieInfoLayoutCard_type.LotteRepeatMode.LOTTE_REPEAT_MODE_REVERSE) {
            if (playCount.current < Number(info.lotteStyle.repeatCount) ||
                Number(info.lotteStyle.repeatCount) === -1) {
                playCount.current += 1;
                const newDirection = direction.current === 1 ? -1 : 1;
                direction.current = newDirection;
                anim.setDirection(newDirection);
            }
        }
    }, [direction, info.lotteStyle, playCount]);
    React.useEffect(() => {
        if (lottieElement.current) {
            const anim = lottie__default['default'].loadAnimation({
                container: lottieElement.current,
                renderer: "svg",
                autoplay: false,
                loop: false,
                path: info.lotteUrl,
                assetsPath: info.lotteAssets,
            });
            anim.addEventListener("DOMLoaded", () => dataReadyEvent(anim));
            anim.addEventListener("complete", () => onAnimationComplete(anim));
        }
    }, [dataReadyEvent, info, onAnimationComplete]);
    return (React__default['default'].createElement(React__default['default'].Fragment, null,
        React__default['default'].createElement("button", { ref: lottieElement, style: style, onClick: onLottieClick, type: "button" })));
};

const LottieInfoLayoutCardRenderer = ({ info, style, position, }) => {
    return (React__default['default'].createElement(React__default['default'].Fragment, null, info.map((lottieInfo, index) => (React__default['default'].createElement(LottieInfoLayoutCard, { info: lottieInfo, key: lottieInfo.id, style: Object.assign({}, dynamicSizing.computeDimentionStylesForComponent({ style })), position: position * 100 + index })))));
};

exports.LottieInfoLayoutCardRenderer = LottieInfoLayoutCardRenderer;
//# sourceMappingURL=LottieInfoLayoutCardRenderer-2f40f7b4.js.map
